var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 22,
    viewBox: "0 0 31 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7273 12.5073C23.554 13.7473 24.834 15.4273 24.834 17.6673V21.6673H30.1673V17.6673C30.1673 14.7606 25.4073 13.0407 21.7273 12.5073ZM19.5007 11.0007C22.4473 11.0007 24.834 8.61398 24.834 5.66732C24.834 2.72065 22.4473 0.333984 19.5007 0.333984C18.874 0.333984 18.2873 0.467317 17.7273 0.653984C18.8747 2.07294 19.5006 3.84252 19.5006 5.66732C19.5006 7.49211 18.8747 9.26169 17.7273 10.6807C18.2873 10.8673 18.874 11.0007 19.5007 11.0007ZM11.5007 11.0007C14.4473 11.0007 16.834 8.61398 16.834 5.66732C16.834 2.72065 14.4473 0.333984 11.5007 0.333984C8.55398 0.333984 6.16732 2.72065 6.16732 5.66732C6.16732 8.61398 8.55398 11.0007 11.5007 11.0007ZM11.5007 3.00065C12.9673 3.00065 14.1673 4.20065 14.1673 5.66732C14.1673 7.13398 12.9673 8.33398 11.5007 8.33398C10.034 8.33398 8.83398 7.13398 8.83398 5.66732C8.83398 4.20065 10.034 3.00065 11.5007 3.00065ZM11.5007 12.334C7.94065 12.334 0.833984 14.1207 0.833984 17.6673V21.6673H22.1673V17.6673C22.1673 14.1207 15.0606 12.334 11.5007 12.334ZM19.5007 19.0007H3.50065V17.6807C3.76732 16.7206 7.90065 15.0007 11.5007 15.0007C15.1006 15.0007 19.234 16.7206 19.5007 17.6673V19.0007Z",
    fill: "#2A5578"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.70eca6781afe81ad30c9683f65fa4e9e.svg";
export { ForwardRef as ReactComponent };